<template>
  <div class="address-book-page">
    <common-header />
    <div class="address-book-body">
      <section class="address-book-content bg-white radius-20 padding-30">
        <div class="flex align-center justify-between margin-bottom-20">
          <div class="flex align-center">
            <i class="el-icon-arrow-left text-bold" @click="$router.back()"></i>
            <span class="text-21-color text-bold padding-left-10">通讯录</span>
          </div>
          <el-button class="add-btn" type="primary" @click="handleAdd">
            添加
          </el-button>
        </div>

        <div class="address-book-table-wrapper">
          <el-table
            :data="addressBookList"
            v-loading="loading"
            style="width: 100%"
            class="address-book-table"
            :show-header="true"
          >
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="email"
              label="邮箱"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="statusText"
              label="状态"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  class="action-link"
                  @click="handleEdit(scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="text"
                  class="action-link delete"
                  @click="handleDelete(scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="address-book-pagination" v-if="total > 0">
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page="page"
              :page-size="limit"
              :total="total"
              @current-change="handlePageChange"
            />
          </div>
        </div>
      </section>
    </div>

    <!-- 添加/编辑弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      width="500px"
      custom-class="address-book-dialog"
      :show-close="false"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="addressBookForm"
        label-width="80px"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="dialog-btn ghost" @click="dialogVisible = false">
          取消
        </el-button>
        <el-button
          class="dialog-btn solid"
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit"
        >
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue";
import {
  getAddressBookList,
  addAddressBook,
  editAddressBook,
  deleteAddressBook,
} from "@/api/dictionary";

export default {
  name: "AddressBook",
  components: { CommonHeader },
  data() {
    return {
      loading: false,
      addressBookList: [],
      page: 1,
      limit: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: "添加联系人",
      isEdit: false,
      submitLoading: false,
      form: {
        id: null,
        name: "",
        email: "",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱格式",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  mounted() {
    this.fetchAddressBookList();
  },
  methods: {
    // 获取通讯录列表
    fetchAddressBookList() {
      this.loading = true;
      getAddressBookList({
        page: this.page,
        limit: this.limit,
      })
        .then((response) => {
          this.loading = false;
          const payload = response.data || {};
          this.total =
            Number(payload.total ?? payload.total_count ?? payload.count) || 0;
          if (response.data && response.data.list) {
            this.addressBookList = response.data.list.map((item) => ({
              ...item,
              statusText: item.status_text || item.status || "-",
            }));
            if (!this.total) {
              this.total = this.addressBookList.length;
            }
          } else if (Array.isArray(response.data)) {
            this.addressBookList = response.data.map((item) => ({
              ...item,
              statusText: item.status_text || item.status || "-",
            }));
            this.total = this.addressBookList.length;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.addressBookList = [];
          this.total = 0;
          console.error("获取通讯录列表失败:", error);
        });
    },
    handlePageChange(page) {
      this.page = page;
      this.fetchAddressBookList();
    },
    // 添加
    handleAdd() {
      this.isEdit = false;
      this.dialogTitle = "添加联系人";
      this.form = {
        id: null,
        name: "",
        email: "",
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.addressBookForm) {
          this.$refs.addressBookForm.clearValidate();
        }
      });
    },
    // 编辑
    handleEdit(row) {
      this.isEdit = true;
      this.dialogTitle = "编辑联系人";
      this.form = {
        id: row.id,
        name: row.name,
        email: row.email,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.addressBookForm) {
          this.$refs.addressBookForm.clearValidate();
        }
      });
    },
    // 删除
    handleDelete(row) {
      this.$confirm("确定要删除该联系人吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAddressBook({ id: row.id })
            .then(() => {
              this.$message.success("删除成功");
              this.fetchAddressBookList();
            })
            .catch((error) => {
              this.$message.error(error.message || "删除失败，请稍后重试");
            });
        })
        .catch(() => {});
    },
    // 提交
    handleSubmit() {
      this.$refs.addressBookForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          const apiMethod = this.isEdit ? editAddressBook : addAddressBook;
          const data = {
            name: this.form.name,
            email: this.form.email,
          };
          if (this.isEdit) {
            data.id = this.form.id;
          }

          apiMethod(data)
            .then(() => {
              this.submitLoading = false;
              this.$message.success(this.isEdit ? "编辑成功" : "添加成功");
              this.dialogVisible = false;
              this.fetchAddressBookList();
            })
            .catch((error) => {
              this.submitLoading = false;
              this.$message.error(
                error.message ||
                  (this.isEdit
                    ? "编辑失败，请稍后重试"
                    : "添加失败，请稍后重试")
              );
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.address-book-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #fff6f8 0%, #f3f7ff 100%);
}

.address-book-body {
  max-width: 1200px;
  margin: 20px auto 60px;
}

.address-book-content {
  box-shadow: 0 12px 30px rgba(31, 46, 134, 0.08);
}

.add-btn {
  width: 102px;
  height: 34px;
  background: #d85a70;
  border-radius: 7px;
  border: none;
  color: #fff;

  &:hover {
    background: #c54a60;
  }
}

.address-book-table-wrapper {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
}

.address-book-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 16px 20px 20px;
}

/* 通讯录表格样式 - 参考Profile页面的推广人数表格 */
::v-deep .address-book-table {
  border: none;

  .el-table__header-wrapper {
    border: none;
    background: transparent;
  }

  .el-table__body-wrapper {
    border: none;
  }

  .el-table__header {
    background: transparent;

    tr {
      background: transparent;
    }

    th {
      background: transparent !important;
      color: #212121;
      font-weight: 600;
      border: none;
      border-bottom: none;
      border-right: none;
      padding: 12px 0;

      &:last-child {
        border-right: none;
      }
    }
  }

  .el-table__body {
    tr {
      background: #fff;

      td {
        border: none;
        border-bottom: none;
        border-right: none;
        color: #000;
        padding: 12px 0;
        background: transparent;

        &:last-child {
          border-right: none;
        }
      }

      /* 单数行（奇数行）添加背景色 */
      &:nth-child(odd) {
        background: #fdf6f8;

        td {
          background: transparent;
        }
      }

      /* 偶数行保持白色 */
      &:nth-child(even) {
        background: #fff;

        td {
          background: transparent;
        }
      }

      &:last-child td {
        border-bottom: none;
      }

      &:hover {
        background: #ede7ff;

        td {
          background: transparent;
        }
      }
    }
  }

  /* 移除所有内部边框 */
  .el-table__border {
    display: none;
  }

  .el-table__border::after,
  .el-table__inner-wrapper::before {
    display: none;
  }

  /* 移除列之间的边框 */
  .el-table td,
  .el-table th {
    border-right: none !important;
  }

  .el-table th:first-child,
  .el-table td:first-child {
    border-left: none !important;
  }
}

.action-link {
  color: #d85a70;
  padding: 0 8px;
  font-size: 14px;

  &:hover {
    color: #c54a60;
  }

  &.delete {
    color: #ff383c;

    &:hover {
      color: #e02f33;
    }
  }
}

/* 弹窗样式 */
.address-book-dialog ::v-deep .el-dialog {
  border-radius: 12px;
}

.address-book-dialog ::v-deep .el-dialog__header {
  border-bottom: 1px solid #ebeef5;
  padding: 20px;
}

.address-book-dialog ::v-deep .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #212121;
}

.address-book-dialog ::v-deep .el-dialog__body {
  padding: 30px 20px;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 20px 0;
}

.dialog-btn {
  border-radius: 57px;
  width: 158px;
  height: 45px;
}

.dialog-btn.ghost {
  color: #d85a70;
  border-color: #d85a70;
  background: #fff;

  &:hover {
    background: #fff6f8;
    border-color: #d85a70;
    color: #d85a70;
  }
}

.dialog-btn.solid {
  background: #d85a70;
  border-color: #d85a70;
  color: #fff;

  &:hover {
    background: #c54a60;
    border-color: #c54a60;
  }
}
</style>
